import { render, staticRenderFns } from "./PurchaseAirlines.vue?vue&type=template&id=09e06434&"
import script from "./PurchaseAirlines.vue?vue&type=script&lang=js&"
export * from "./PurchaseAirlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports